import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import tesbihLogo from '../../assets/tesbihlogo.PNG';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase/firebase-config';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/admin');
    } catch (err) {
      setError("Giriş bilgileri hatalı.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <img src={tesbihLogo} alt="Tesbihçimen" className="login-logo" />
          <h1>Yönetim Paneli</h1>
          <p>Devam etmek için lütfen giriş yapın.</p>
        </div>

        <form onSubmit={handleLogin} className="login-form">
          <div className="input-container">
            <div className="input-group">
              <label>E-POSTA ADRESİ</label>
              <input 
                type="email" 
                placeholder="admin@tesbihcimen.com" 
                onChange={(e) => setEmail(e.target.value)} 
                required 
              />
            </div>
            
            <div className="input-group">
              <label>GİRİŞ ŞİFRESİ</label>
              <input 
                type="password" 
                placeholder="••••••••" 
                onChange={(e) => setPassword(e.target.value)} 
                required 
              />
            </div>
          </div>
          
          {error && <div className="error-box">{error}</div>}
          
          <button type="submit" className="login-btn">
            SİSTEME GİRİŞ YAP
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;